import CenterServiceModal, { ICenterServiceModalProps } from "../Components/CenterServiceModal";
import ServiceSelector from "../Components/ServiceSelector";

/** A {@link CenterServiceModal} with the selector element provisioned. */
const CenterServiceModalSelector: React.FC<Omit<ICenterServiceModalProps, "ServiceSelector">> = props =>
  CenterServiceModal({ ...props, ServiceSelector });

export default CenterServiceModalSelector;
